(function () {
  var SELECTORS = {
    root: '[data-444-cookie-preferences]',
    hook: '[data-444-cookie-preferences-hook]',
    dialog: '[data-444-cookie-dialog]',
    close: '[data-444-cookie-close]',
    action: '[data-444-cookie-action]',
    toggle: '[data-444-cookie-toggle]',
    status: '[data-444-cookie-status]',
  };

  var CATEGORIES = ['preferences', 'analytics', 'marketing'];
  var controller = null;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getFocusable(container) {
    return toArray(
      container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return !element.disabled && element.getAttribute('aria-hidden') !== 'true';
    });
  }

  function normalizeConsent(consent) {
    consent = consent || {};
    return {
      preferences: consent.preferences === 'yes',
      analytics: consent.analytics === 'yes',
      marketing: consent.marketing === 'yes',
    };
  }

  function setStatus(root, message, kind) {
    var status = root.querySelector(SELECTORS.status);
    if (!status) return;
    status.textContent = message || '';
    status.classList.remove('is-error', 'is-success');
    if (kind) status.classList.add('is-' + kind);
  }

  function CookiePreferences(root) {
    this.root = root;
    this.dialog = root.querySelector(SELECTORS.dialog);
    this.hooks = [];
    this.hookRegistry = new WeakSet();
    this.api = null;
    this.ready = false;
    this.open = false;
    this.opener = null;
    this.draft = { preferences: false, analytics: false, marketing: false };
    this.boundOpen = this.handleOpen.bind(this);
    this.boundClick = this.handleClick.bind(this);
    this.boundKeydown = this.handleKeydown.bind(this);
    this.boundConsent = this.handleExternalConsent.bind(this);
  }

  CookiePreferences.prototype.init = function () {
    this.hooks = toArray(document.querySelectorAll(SELECTORS.hook));
    this.hooks.forEach(
      function (hook) {
        if (this.hookRegistry.has(hook)) return;
        this.hookRegistry.add(hook);
        hook.addEventListener('click', this.boundOpen);
      }.bind(this)
    );
    if (this.root.dataset.initialized === 'true') return;
    this.root.dataset.initialized = 'true';
    this.root.addEventListener('click', this.boundClick);
    document.addEventListener('keydown', this.boundKeydown);
    document.addEventListener('visitorConsentCollected', this.boundConsent);
    this.loadApi();
  };

  CookiePreferences.prototype.loadApi = function () {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      setStatus(this.root, this.root.dataset.apiUnavailableText, 'error');
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          setStatus(this.root, this.root.dataset.apiUnavailableText, 'error');
          return;
        }
        this.api = window.Shopify.customerPrivacy;
        this.ready = true;
        this.syncFromConsent();
      }.bind(this)
    );
  };

  CookiePreferences.prototype.syncFromConsent = function () {
    if (!this.ready || !this.api || typeof this.api.currentVisitorConsent !== 'function') return;
    this.draft = normalizeConsent(this.api.currentVisitorConsent());
    this.renderDraft();
  };

  CookiePreferences.prototype.renderDraft = function () {
    CATEGORIES.forEach(
      function (category) {
        var toggle = this.root.querySelector('[data-444-cookie-toggle="' + category + '"]');
        if (!toggle) return;
        toggle.setAttribute('aria-checked', this.draft[category] ? 'true' : 'false');
      }.bind(this)
    );
  };

  CookiePreferences.prototype.handleOpen = function (event) {
    event.preventDefault();
    this.opener = event.currentTarget || event.target;
    this.openDialog();
  };

  CookiePreferences.prototype.openDialog = function () {
    this.root.hidden = false;
    this.dialog.hidden = false;
    this.open = true;
    document.documentElement.classList.add('cookie-preferences-scroll-lock');
    if (!this.ready) {
      setStatus(this.root, this.root.dataset.apiUnavailableText, 'error');
    } else {
      this.syncFromConsent();
      setStatus(this.root, '', null);
    }
    var focusable = getFocusable(this.dialog);
    if (focusable.length) focusable[0].focus();
  };

  CookiePreferences.prototype.closeDialog = function () {
    this.dialog.hidden = true;
    this.root.hidden = true;
    this.open = false;
    document.documentElement.classList.remove('cookie-preferences-scroll-lock');
    if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
    this.opener = null;
  };

  CookiePreferences.prototype.handleClick = function (event) {
    var close = event.target.closest ? event.target.closest(SELECTORS.close) : null;
    if (close) {
      this.closeDialog();
      return;
    }

    if (event.target === this.root) {
      this.closeDialog();
      return;
    }

    var toggle = event.target.closest ? event.target.closest(SELECTORS.toggle) : null;
    if (toggle && !toggle.disabled) {
      var category = toggle.dataset['444CookieToggle'];
      this.draft[category] = !this.draft[category];
      this.renderDraft();
      return;
    }

    var action = event.target.closest ? event.target.closest(SELECTORS.action) : null;
    if (!action) return;
    var actionName = action.dataset['444CookieAction'];
    if (actionName === 'save') this.save(this.draft, true);
    if (actionName === 'accept') this.save({ preferences: true, analytics: true, marketing: true }, true);
    if (actionName === 'reject') this.save({ preferences: false, analytics: false, marketing: false }, true);
  };

  CookiePreferences.prototype.save = function (payload, shouldCloseOnSuccess) {
    if (!this.ready || !this.api || typeof this.api.setTrackingConsent !== 'function') {
      setStatus(this.root, this.root.dataset.apiUnavailableText, 'error');
      return;
    }

    this.draft = {
      preferences: !!payload.preferences,
      analytics: !!payload.analytics,
      marketing: !!payload.marketing,
    };
    this.renderDraft();

    this.api.setTrackingConsent(
      {
        preferences: this.draft.preferences,
        analytics: this.draft.analytics,
        marketing: this.draft.marketing,
      },
      function (error) {
        if (error) {
          setStatus(this.root, this.root.dataset.saveErrorText, 'error');
          return;
        }
        setStatus(this.root, this.root.dataset.saveSuccessText, 'success');
        if (shouldCloseOnSuccess) this.closeDialog();
      }.bind(this)
    );
  };

  CookiePreferences.prototype.handleExternalConsent = function () {
    this.syncFromConsent();
  };

  CookiePreferences.prototype.handleKeydown = function (event) {
    if (!this.open) return;
    if (event.key === 'Escape') {
      this.closeDialog();
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = getFocusable(this.dialog);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  CookiePreferences.prototype.destroy = function () {
    this.hooks.forEach(
      function (hook) {
        hook.removeEventListener('click', this.boundOpen);
      }.bind(this)
    );
    this.root.removeEventListener('click', this.boundClick);
    document.removeEventListener('keydown', this.boundKeydown);
    document.removeEventListener('visitorConsentCollected', this.boundConsent);
    this.root.dataset.initialized = 'false';
  };

  function init() {
    var root = document.querySelector(SELECTORS.root);
    if (!root) return null;
    if (!controller) controller = new CookiePreferences(root);
    controller.init();
    return controller;
  }

  window.FourFortyFourCookiePreferences = {
    init: init,
    getController: function () {
      return controller;
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
